// src/App.js
import React, { useState, useEffect, Suspense, lazy } from 'react';
import LoadingScreen from './LoadingScreen';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import Navbar from './Navbar';
import TopRightMenu from './TopRightMenu';
import { useFocusMode } from './FocusModeContext';
import { signOut, auth } from './firebase';
import CookieConsent from "react-cookie-consent";
const RequestDemoClass = lazy(() => import('./RequestDemoClass'));
const RequestDemoClassThankYou = lazy(() => import('./RequestDemoClassThankYou'));
const TutorApplyPage = lazy(() => import('./TutorApplyPage'));
const DemoCallPage = React.lazy(() => import('./DemoCallPageAcs'));
const AdminScheduler = React.lazy(() => import('./AdminScheduler'));
const AmbientSoundPlayer = React.lazy(() => import('./AmbientSoundPlayer'));
const FeaturesPage = React.lazy(() => import("./FeaturesPage"));
const AboutPage = React.lazy(() => import("./AboutPage"));
const GradeTopics = React.lazy(() => import('./pages/GradeTopics'));
const CookiePolicy = React.lazy(() => import('./pages/CookiePolicy'));
const Signup = React.lazy(() => import('./Signup'));
const TutorDashboard = React.lazy(() => import('./TutorDashboard'));
const Home = React.lazy(() => import('./Home'));
const SignupHome = React.lazy(() => import('./SignupHome'));
const FreeSpace = React.lazy(() => import('./FreeSpace'));
const Subscribe = React.lazy(() => import('./Subscribe'));
const SubjectGradePage = React.lazy(() => import('./SubjectGradePage'));
const TopicQuizPage = React.lazy(() => import('./TopicQuizPage'));
const TopicConceptPage = React.lazy(() => import('./TopicConceptPage'));
const MathQuizRouter = React.lazy(() => import('./MathQuizRouter'));
const GradeScienceQuiz = React.lazy(() => import('./data/Science/GradeScienceQuiz'));
const Leaderboard = React.lazy(() => import('./Leaderboard'));
const PrivacyPolicy = React.lazy(() => import('./PrivacyPolicy'));
const TermsOfUse = React.lazy(() => import('./TermsOfUse'));
const GradeSSCQuizTailored = React.lazy(() => import('./GradeSSCQuizTailored'));
const Login = React.lazy(() => import('./Login'));
const SubscriberPage = React.lazy(() => import('./SubscriberPage'));
const SubscriberDashboard = React.lazy(() => import('./SubscriberDashboard'));

console.log('Running React in:', process.env.NODE_ENV, 'mode');

function App() {
  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');
  const [status, setStatus] = useState(localStorage.getItem('subscriptionStatus') || 'free');

  useEffect(() => {
    if (!localStorage.getItem('userId')) {
      localStorage.setItem('userId', crypto.randomUUID());
    }
  }, []);

  const handleSignOut = async () => {
    await signOut(auth);
    localStorage.clear();
    setUserName('');
    setStatus('free');
  };

  const normalizedStatus = (status || '').trim().toLowerCase();
  const isSubscriber = ['freetrial', 'freeTrial', 'monthly', 'yearly', 'trial', 'subscribed'].includes(normalizedStatus);
const { focusMode, ambientOn, setAmbientOn } = useFocusMode();
const shouldPlaySound = focusMode && ambientOn;

  return (
<>
      {/* Mount the player and PASS the prop */}
      <AmbientSoundPlayer isPlaying={shouldPlaySound} />

      {/* TEMP: a tiny test button so you can flip it on/off */}
  <Router>
    <Navbar userName={userName} handleSignOut={handleSignOut} />
        {/* Later, wire your menu like this: */}
        <TopRightMenu ambientOn={ambientOn} setAmbientOn={setAmbientOn} />
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path="/" element={
            isSubscriber
              ? <Navigate to="/subscriber-dashboard" replace />
              : <Home userName={userName} setUserName={setUserName} />
          } />
          <Route path="/signup" element={<Signup setUserName={setUserName} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/quiz/:subjectName/:gradeLevel" element={<GradeTopics />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/free" element={<FreeSpace userName={userName} />} />
          <Route path="/free/:subjectName/:gradeLevel" element={<FreeSpace userName={userName} />} />
          <Route path="/free/:subjectName" element={<FreeSpace userName={userName} />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/subject" element={<SubjectGradePage />} />
          <Route path="/subject/:subjectName" element={<SubjectGradePage />} />
          <Route path="/subject/:subjectName?" element={<SubjectGradePage />} />
          <Route path="/quiz/:subjectName/:gradeLevel" element={<TopicQuizPage />} />
          <Route path="/quiz/Science/:gradeLevel/:topicName" element={<GradeScienceQuiz />} />
          <Route path="/quiz/:subjectName/:gradeLevel/:topicName" element={<MathQuizRouter />} />
          <Route path="/quiz/Math/:gradeLevel/:topicName" element={<MathQuizRouter />} />
          <Route path="/quiz/:subjectName/:gradeLevel/:topicName/leaderboard" element={<Leaderboard />} />
          <Route path="/concept/:conceptId" element={<TopicConceptPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/tutor-dashboard" element={<TutorDashboard />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/quiz/Aptitude/:topicName" element={<GradeSSCQuizTailored />} />
          <Route path="/login" element={<Login setUserName={setUserName} />} />
          <Route path="/subscriber" element={<SubscriberPage />} />
          <Route path="/subscriber-dashboard" element={<SubscriberDashboard/>} />
          <Route path="/signup-home" element={<SignupHome />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/demo-call/:roomId" element={<DemoCallPage />} />
          <Route path="/admin/scheduler" element={<AdminScheduler />} />
          <Route path="/tutor-apply" element={<TutorApplyPage />} />
          <Route path="/request-demo-class" element={<RequestDemoClass />} />
          <Route path="/request-demo-class/thank-you" element={<RequestDemoClassThankYou />} />
        </Routes>
    </Suspense>
  </Router>

      {/* ✅ Cookie Consent outside Router */}
      <CookieConsent
        location="bottom"
        buttonText="I understand"
        declineButtonText="Decline"
        enableDeclineButton
        onDecline={() => {
          // Optional: Disable analytics or ad scripts here
          console.log("User declined cookies");
        }}
        cookieName="tutororcaConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        declineButtonStyle={{ background: "#ccc", color: "#000", fontSize: "13px" }}
        expires={150}
      >
        We use cookies to improve your experience and deliver relevant content.{" "}
        <a href="/privacy-policy" style={{ color: "#ffd700" }}>Learn more</a>
        <a href="/terms-of-use" style={{ marginLeft: '15px' }}>Terms of Use</a>
      </CookieConsent>

    </>
  );
}

export default App;
